import inviewAnim from "./modules/common/inview";
import { setModal, globalNav, mastheadNav, accordion, smoothScroll, setPagetop, setHashDetect } from "./modules/common/libs";
import setNewsTab from "./modules/common/setNewsTab";
import setComSlider from "./modules/common/setComSlider";
import setMainFixedHeader from "./modules/top/setMainFixedHeader";
import setBannerSlider from "./modules/top/setBannerSlider";
import setSlider from "./modules/campus/setSlider";
import setBlogSlider from "./modules/campus/setBlogSlider";
import setScheduleSlider from "./modules/campus/setScheduleSlider";
import setGallery from "./modules/campus/setGallery";
import setMovie from "./modules/campus/setMovie";
import setCourseTab from "./modules/campus/setCourseTab";
import setMapSlider from "./modules/campus/setMapSlider";
import setAccessibility from "./modules/common/setAccessibility";
import setFixedHeader from "./modules/admissions/setFixedHeader";
import setCampusSlider from "./modules/admissions/setCampusSlider";
import { setHeroSlider } from './modules/admissions/setHeroSlider';
import setAdmissionsTopInitAnim from "./modules/admissions/setAdmissionsTopInitAnim";

import setSchedule from "./modules/admissions/setSchedule";
import setGallerySlider from "./modules/admissions/setGallerySlider";
import setOpencampusNav from "./modules/admissions/setOpencampusNav";

const hash = location.hash;
if (hash && !/^[a-zA-Z0-9\-_]+$/.test(hash.slice(1))) {
  history.replaceState(null, null, location.pathname + location.search);
}

window.addEventListener('load', () => {
  setHashDetect();

  setHeroSlider();
  setAdmissionsTopInitAnim();

  inviewAnim();
  globalNav();
  mastheadNav();
  accordion();
  smoothScroll();
  setNewsTab();
  setComSlider();
  setMainFixedHeader();
  setBannerSlider();
  setSlider();
  setBlogSlider();
  setScheduleSlider();
  setGallery();
  setMovie();
  setCourseTab();
  setMapSlider();
  setAccessibility();
  setFixedHeader();
  smoothScroll();
  setCampusSlider();
  setPagetop();
  setSchedule();
  setGallerySlider();
  setOpencampusNav();
})